import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationEN from './core/locales/en/translation';
import translationDE from './core/locales/de/translation';
import translationSR from './core/locales/sr/translation';

const resources = {
  en: {
    translation: translationEN,
  },
  de: {
    translation: translationDE,
  },
  sr: {
    translation: translationSR,
  },
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    fallbackLng: 'en', // use en if detected lng is not available
    keySeparator: true,
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
